import BackgroundColorTools from './BackgroundColorTools';

export default BackgroundColorTools;
